import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Loader} from 'semantic-ui-react';

class Orders extends Component {
  constructor(props) {
    super(props);
    this.state = { };
  }

  renderOrdersDetail() {
    const {orders} = this.props;

    return orders.map((order, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='left'>{order.orderCode}</Table.Cell>
          <Table.Cell textAlign='right'>{order.quantity}</Table.Cell>
        </Table.Row>
      );
    });
  }

  getTotal() {
    const {orders = []} = this.props;

    return orders.reduce((total, order) => {
      return total + order.quantity;
    }, 0);
  }

  render() {
    const {loading, orders} = this.props;

    if (loading) {
      return (<Loader active inline='centered'>Consultando...</Loader>);
    }

    return (
      <div className='table-scroll-container'>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan='2'>P. Pendientes de Embarque</Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell textAlign='center' className='fixed'>Pedido</Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='fixed'>Cantidad</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.renderOrdersDetail()}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan='2' textAlign='center'>
                Total: {this.getTotal(orders)}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {loadingOnOrdersDetail, onOrdersDetail} = state.partModals;
  const {pending = []} = onOrdersDetail;

  return {
    'loading': loadingOnOrdersDetail,
    'orders': pending,
  };
};

export default connect(mapStateToProps)(Orders);
